<template>
    <div class="adverts">
        <div class="header form-inline mb-3">
            <div class="form-inline">
                <h4 class="mr-5">Anúncios</h4>
            </div>
        </div>
        <div class="table">
            <form>
                <div class="row">
                    <div class="form-group col-8">
                        <h5>Página Início</h5>
                        <p>Tamanho padrão para imagens é de 520px por 99px</p>
                        <img
                            v-if="announcementStart"
                            :src=announcementStart
                            alt="Foto Anúncio"
                        >
                        <img
                            v-else
                            src="../../assets/img/sem-anuncio.png"
                            alt="Foto Anúncio"
                        >
                        <div class="mt-2">
                            <input type="file" class="d-none" accept=".jpg, .jpeg, .png" ref="inputFile1" @change="handleFile($event, 'announcementStart')">
                            <button type="button" class="btn btn-outline-secondary" @click="openFileDialog1()">
                                Adicionar Foto
                            </button>
                            <button type="button" class="btn btn-outline-danger ml-2" v-if="(announcementStart)"
                                @click="clearAnnouncementStart()">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row mt-3">
                    <div class="form-group col-8">
                        <h5>Página Fontes</h5>
                        <p>Tamanho padrão para imagens é de 520px por 99px</p>
                        <img
                            v-if="announcementFonts"
                            :src=announcementFonts
                            alt="Foto Anúncio"
                        >
                        <img
                            v-else
                            src="../../assets/img/sem-anuncio.png"
                            alt="Foto Anúncio"
                        >
                        <div class="mt-2">
                            <input type="file" class="d-none" accept=".jpg, .jpeg, .png" ref="inputFile2" @change="handleFile($event, 'announcementFonts')">
                            <button type="button" class="btn btn-outline-secondary" @click="openFileDialog2()">
                                Adicionar Foto
                            </button>
                            <button type="button" class="btn btn-outline-danger ml-2" v-if="(announcementFonts)"
                                @click="clearAnnouncementFonts()">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row mt-3">
                    <div class="form-group col-8">
                        <h5>Página Legislação</h5>
                        <p>Tamanho padrão para imagens é de 520px por 99px</p>
                        <img
                            v-if="announcementLegislation"
                            :src=announcementLegislation
                            alt="Foto Anúncio"
                        >
                        <img
                            v-else
                            src="../../assets/img/sem-anuncio.png"
                            alt="Foto Anúncio"
                        >
                        <div class="mt-2">
                            <input type="file" class="d-none" accept=".jpg, .jpeg, .png" ref="inputFile3" @change="handleFile($event, 'announcementLegislation')">
                            <button type="button" class="btn btn-outline-secondary" @click="openFileDialog3()">
                                Adicionar Foto
                            </button>
                            <button type="button" class="btn btn-outline-danger ml-2" v-if="(announcementLegislation)"
                                @click="clearAnnouncementLegislation()">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Adverts',
  data: () => ({
    announcementStart: '',
    announcementFonts: '',
    announcementLegislation: '',
    ref: '',
    file: ''
  }),
  methods: {
    getAnnouncementStart () {
      this.ref = this.$firebase.database().ref('parameters/announcementStart')
        .on('value', (data) => {
          this.announcementStart = data.val()
        })
    },
    getAnnouncementFonts () {
      this.ref = this.$firebase.database().ref('parameters/announcementFonts')
        .on('value', (data) => {
          this.announcementFonts = data.val()
        })
    },
    getAnnouncementLegislation () {
      this.ref = this.$firebase.database().ref('parameters/announcementLegislation')
        .on('value', (data) => {
          this.announcementLegislation = data.val()
        })
    },
    openFileDialog1 () {
      this.$refs.inputFile1.value = null
      this.$refs.inputFile1.click()
    },
    openFileDialog2 () {
      this.$refs.inputFile2.value = null
      this.$refs.inputFile2.click()
    },
    openFileDialog3 () {
      this.$refs.inputFile3.value = null
      this.$refs.inputFile3.click()
    },
    async handleFile (event, field) {
      this.$root.$emit('Spinner::show')
      this.file = event.target.files[0]
      let url = ''

      if (this.file) {
        const file = this.file.name
        const split = file.split('.')
        const fileSplit = `${split[0]}-${new Date().getTime()}.${split[1]}`
        const snapshot = await this.$firebase.storage().ref('adverts')
          .child(fileSplit)
          .put(this.file)

        url = await snapshot.ref.getDownloadURL()

        if (field === 'announcementStart') {
          this.$firebase.database().ref('parameters').update({ announcementStart: url })
        }

        if (field === 'announcementFonts') {
          this.$firebase.database().ref('parameters').update({ announcementFonts: url })
        }

        if (field === 'announcementLegislation') {
          this.$firebase.database().ref('parameters').update({ announcementLegislation: url })
        }

        this.$root.$emit('Spinner::hide')
      }
    },
    clearAnnouncementStart () {
      this.Ref = this.$firebase.database().ref('parameters').update({ announcementStart: '' })
    },
    clearAnnouncementFonts () {
      this.Ref = this.$firebase.database().ref('parameters').update({ announcementFonts: '' })
    },
    clearAnnouncementLegislation () {
      this.Ref = this.$firebase.database().ref('parameters').update({ announcementLegislation: '' })
    }
  },
  created () {
    this.getAnnouncementStart()
    this.getAnnouncementFonts()
    this.getAnnouncementLegislation()
  }
}
</script>

<style lang="scss" scoped>
.adverts {
  padding: 40px 60px;
  height: 100%;
  .header {
    display: flex;
    justify-content: space-between;
  }
}
</style>
